"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.find-index.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _interface = require("../interface");
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../../_utils/hooks/usePrefixCls");
var _excluded = ["size", "color", "className", "style"]; // GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
/* eslint-disable */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var WaitingIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('icon');
  var size = props.size,
    color = props.color,
    className = props.className,
    customStyle = props.style,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var isFontSize = false;
  var isSize = false;
  if (typeof size === 'number') {
    isFontSize = true;
  } else {
    isSize = _interface.SizeTypes.findIndex(function (item) {
      return item === size;
    }) !== -1;
  }
  var classes = (0, _classnames.default)(prefixCls, prefixCls + '--' + 'waiting', (0, _defineProperty2.default)({}, 'size-' + size, isSize), className);
  var style = _objectSpread({
    color: color,
    fontSize: isFontSize ? size : undefined
  }, customStyle);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    ref: ref,
    className: classes,
    style: style
  }, restProps, {
    height: "16px",
    width: "16px",
    version: "1.1",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("title", null, "waiting"), /*#__PURE__*/_react.default.createElement("g", {
    id: "waiting",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "\u7F16\u7EC4",
    transform: "translate(-0.560660, 0.000000)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    height: "16",
    id: "\u77E9\u5F62",
    width: "16",
    x: "0.560660172",
    y: "0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "\u5F62\u72B6\u7ED3\u5408",
    d: "M9.56066017,1 C13.4266534,1 16.5606602,4.13400675 16.5606602,8 C16.5606602,11.8659932 13.4266534,15 9.56066017,15 C7.68919527,15 5.98926202,14.2655857 4.73334281,13.0692395 L6.14851506,11.6547844 C7.04196146,12.4892707 8.24166721,13 9.56066017,13 C12.3220839,13 14.5606602,10.7614237 14.5606602,8 C14.5606602,5.23857625 12.3220839,3 9.56066017,3 C6.94491729,3 4.7983107,5.00861122 4.57909924,7.56757482 L2.70868226,9.43882747 C2.61166313,8.97445521 2.56066017,8.49318379 2.56066017,8 C2.56066017,4.13400675 5.69466692,1 9.56066017,1 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "\u77E9\u5F62",
    d: "M8.06066017,5 L10.0606602,5 L10.0606602,9 C10.0606602,9.55228475 9.61294492,10 9.06066017,10 C8.50837542,10 8.06066017,9.55228475 8.06066017,9 L8.06066017,5 L8.06066017,5 Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "\u77E9\u5F62",
    d: "M8.92622231,7.50172892 L10.9262223,7.50172892 L10.9262223,10.5017289 C10.9262223,11.0540137 10.4785071,11.5017289 9.92622231,11.5017289 L8.92622231,11.5017289 L8.92622231,11.5017289 L8.92622231,7.50172892 Z",
    fill: "currentColor",
    transform: "translate(9.926222, 9.501729) rotate(-240.000000) translate(-9.926222, -9.501729) "
  })), /*#__PURE__*/_react.default.createElement("polygon", {
    id: "\u77E9\u5F62",
    fill: "currentColor",
    points: "1.02842712 5.53553391 5.02842712 5.53553391 5.02842712 9.53553391",
    transform: "translate(3.028427, 7.535534) scale(1, -1) rotate(-45.000000) translate(-3.028427, -7.535534) "
  })));
});
var _default = exports.default = WaitingIcon;